import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks/useRedux';

interface PermissionProtectedRouteProps {
    children: React.ReactNode;
    requiredCategory: string;
    requiredPermission: string;
}

const hasPermission = (permissions: any, category: string, permission: string): boolean => {
    if (!permissions) return false;
    return permissions[category]?.[permission] || false;
};

const PermissionProtectedRoute: React.FC<PermissionProtectedRouteProps> = ({
    children,
    requiredCategory,
    requiredPermission
}) => {
    const { permissions, user, role_id } = useAppSelector((state) => state.auth);

    // If user is not logged in, redirect to login
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // If user is logged in but doesn't have permission, redirect to unauthorized
    if (!hasPermission(permissions, requiredCategory, requiredPermission) && role_id !== 1) {
        return <Navigate to="/not-authorized" replace />;
    }

    // User is logged in and has permission
    return <>{children}</>;
};

export default PermissionProtectedRoute; 